<template>
  <div class="page-tab">
    <div class="tab_ctn">
      <template v-for="pageName in pageList">
        <div class="tab_box" :class="{active: currentPage === pageName}">
          <div class="tab" @click="toPage(pageName)">
            <div class="icon" :style="iconStyle(pageName)">
              <template v-if="pageName === 'notification'">
                <div class="unread">32</div>
              </template>
            </div>
            <div class="name">{{$tp(`pageTab.${pageName}`)}}</div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
let fileName = require.context("@c/PageTab/img", true, /\.svg$/).keys();
fileName = fileName.map(path => path.replace(/^\.\//, "").replace(/\.svg$/, ""));
export default {
  data() {
    return {
      pageList: [
        "channel",
        // "notification", 
        "setting"
      ],
      tab: "",
    }
  },
  computed: {
    currentPage() {
      return this.$route.name
    }
  },
  created() {
    this.tab = this.currentPage
    //預設路徑
    if (this.$route.name === "index") {
      this.tab = this.pageList[0];
      this.$router.replace({ name: this.tab });
    }
  },
  methods: {
    iconStyle(pageName) {
      let no = pageName === this.currentPage ? 2 : "";
      return {
        backgroundImage: `url(${this.imagePath(pageName, no)})`
      }
    },
    imagePath(pageName, no = "") {
      let result = undefined;
      if (fileName.includes(pageName)) {
        result = require(`@c/PageTab/img/${pageName}${no}.svg`);
      }
      return result;
    },
    toPage(pageName) {
      if (this.tab === pageName) return false;
      this.tab = pageName;

      this.$router.replace({ name: this.tab });
    }
  },
  watch: {
    currentPage() {
      this.tab = this.currentPage;
    }
  }
}
</script>

<style lang="scss" scoped>
.page-tab {
  border-top: 0.3px solid #3c3c435c;
  background-color: #ffffff;
  backdrop-filter: blur(20px);
  box-shadow: 0px -1px 8px 0px #02061714;

  .tab_ctn {
    display: flex;
    padding-bottom: 0.5em;
    max-width: 17rem;
    margin: 0 auto;
  }
  .tab_box {
    width: 100%;
    &.active {
      .name {
        color: $main;
      }
    }
  }
  .tab {
    @include buttonEnhance();
    @include common-click();
    padding: 0.5rem 0;
    max-width: 4rem;
    margin: 0 auto;
  }
  .icon {
    position: relative;
    background: no-repeat center;
    background-size: 100% auto;
    width: 1.2rem;
    margin: 0 auto;
    margin-bottom: 0.2rem;
    &::before {
      content: "";
      display: block;
      padding-top: 100%;
    }
  }
  .unread {
    position: absolute;
    top: -0.2rem;
    right: -0.4rem;
  }
  .name {
    text-align: center;
    color: $gray_60;
    font-size: 70%;
  }
}
</style>